module.exports = __webpack_public_path__ + "assets/img/boss_bg.d341cde9.png";